import useSWR from "swr";
import actionsService from "../../services/actions.service";

const SWR_CACHE_KEY = "action/outstanding_count";

const useActionsCount = () => {
    const { data, isLoading, error } = useSWR(SWR_CACHE_KEY, () => actionsService.getOutstandingActionsCount(), {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenHidden: false,
        refreshWhenOffline: false,
        revalidateIfStale: false,
        loadingTimeout: 6000,
    });

    return {
        count: data?.count?.ActionsCount || 0,
        isLoading: isLoading || !data,
        error,
    };
};

export default useActionsCount;
